import eventBus from 'services/eventBus'
import { IFaqArticle, IFaqCategory } from '../faq.types'

const groupCreated = (item: IFaqCategory) => {
  eventBus.pub('faq.groups.created', item)
}

const groupUpdated = (item: Partial<IFaqCategory>, id: IFaqCategory['id']) => {
  eventBus.pub('faq.groups.updated', { updates: item, id })
}

const groupRemoved = (id: IFaqCategory['id']) => {
  eventBus.pub('faq.groups.deleted', id)
}

const articleCreated = (item: IFaqArticle) => {
  eventBus.pub('faq.articles.created', item)
}

const articleUpdated = (item: Partial<IFaqArticle>, id: IFaqArticle['id']) => {
  eventBus.pub('faq.articles.updated', { updates: item, id })
}

const articleRemoved = (id: IFaqArticle['id']) => {
  eventBus.pub('faq.articles.deleted', id)
}

const faqEvents = { groupCreated, groupUpdated, groupRemoved, articleCreated, articleUpdated, articleRemoved }
export default faqEvents
